import type { OutputReference } from "@smartsuite/automation-engine-api";

import type { LeftSource } from "./types";

// eslint-disable-next-line import/no-unused-modules -- consumed by Task 3+
export const buildLeftOutputReference = (
  source: LeftSource,
  conditionFieldId: string,
): OutputReference => ({
  source: source.reference,
  outputId: conditionFieldId,
});
